
export default [
    {
      _name: 'CSidebarNav',
      _children: [
        {
          _name: 'CSidebarNavItem',
          name: 'Dashboard',
          to: '/dashboard',
          icon: 'cil-speedometer',
          badge: {
            color: 'primary',
            text: 'NEW'
          }
        },
        {
          _name: 'CSidebarNavTitle',
          _children: ['Feature']
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Business Inquiry',
          route: '/business_inquiry',
          icon: 'cil-star',
          items: [
            {
              name: 'Pendaftaran',
              to: '/business_inquiry/registration'
            },
            {
              name: 'Listing',
              to: '/business_inquiry/listing'
            }
          ]
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Shortlink',
          to: '/management/shortlink',
          icon: 'cil-link'
        },
      ]
    }
  ]
  
  
